(() => {
  const ADVERTISER_ID = '719525d1ec1645edb53f20a822235a8b';
  const PII_KEY = /(e[-_ ]?mail|phone|tel|customer[-_ ]?id|user[-_ ]?id|first[-_ ]?name|last[-_ ]?name|full[-_ ]?name)/i;

  function sanitize(value, depth = 0) {
    if (value == null || typeof value !== 'object' || depth > 5) return value;
    if (Array.isArray(value)) return value.map((item) => sanitize(item, depth + 1));

    return Object.entries(value).reduce((result, [key, item]) => {
      const normalizedKey = key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
      if (PII_KEY.test(normalizedKey)) return result;
      if (typeof item === 'string' && (/@.+\./.test(item) || /[+\d][\d\s().-]{6,}/.test(item))) return result;
      result[key] = sanitize(item, depth + 1);
      return result;
    }, {});
  }

  function payloadFromEvent(event) {
    const detail = event?.detail || {};
    return detail.data || detail.payload || detail;
  }

  function numberValue(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
    if (typeof value === 'string') {
      const parsed = Number(value.replace(/[^0-9.-]+/g, ''));
      return Number.isFinite(parsed) ? parsed : 0;
    }
    if (value && typeof value === 'object') {
      return numberValue(value.amount ?? value.value);
    }
    return 0;
  }

  function normalizeId(value) {
    if (value == null) return '';
    const parts = String(value).split('/');
    return parts[parts.length - 1] || String(value);
  }

  function currencyFrom(payload) {
    return payload?.currency || payload?.currencyCode || payload?.cart?.cost?.totalAmount?.currencyCode || payload?.cost?.totalAmount?.currencyCode;
  }

  function itemFromProduct(product) {
    const variant = product?.selectedVariant || product?.variant || product?.merchandise || product;
    const productData = variant?.product || product?.product || product;
    const id = variant?.id || productData?.id || product?.id;
    const sku = variant?.sku || productData?.sku || product?.sku;
    return {
      item_id: String(sku || normalizeId(productData?.id || id)),
      item_variant_id: normalizeId(id),
      item_variant: variant?.title || product?.variantTitle || productData?.title || '',
      item_name: productData?.title || product?.name || product?.title || '',
      item_brand: productData?.vendor || product?.vendor || '',
      item_category: productData?.productType || product?.productType || '',
      price: numberValue(variant?.price || product?.price),
      quantity: Number(product?.quantity || product?.qty || 1) || 1,
      image_url: variant?.image?.url || productData?.featuredImage?.url || product?.image?.url || null,
      google_business_vertical: 'retail',
    };
  }

  function itemsFromPayload(payload) {
    const products = [
      ...(payload?.products || []),
      ...(payload?.product ? [payload.product] : []),
      ...(payload?.selectedVariant ? [payload.selectedVariant] : []),
      ...(payload?.variant ? [payload.variant] : []),
      ...(payload?.merchandise ? [payload.merchandise] : []),
    ];
    if (products.length) return products.map(itemFromProduct);

    const lines = payload?.lineItems || payload?.lines || payload?.cart?.lines?.nodes || payload?.items || [];
    return lines.map((line) => itemFromProduct({ ...line, ...(line.merchandise || line.variant || {}) }));
  }

  function mapPayload(eventName, payload) {
    const items = itemsFromPayload(payload);
    const value = numberValue(payload?.value || payload?.cart?.cost?.totalAmount?.amount) || items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    return { currency: currencyFrom(payload), value, items };
  }

  function track(eventName, payload) {
    const pixel = window.InmobiPixel;
    if (typeof pixel !== 'function') return;

    const safePayload = sanitize(mapPayload(eventName, payload || {}));
    pixel('track', eventName, safePayload);

    const history = Array.isArray(window.__glancePayloadHistory) ? window.__glancePayloadHistory : [];
    history.push({ event: eventName, payload: safePayload, advertiser: ADVERTISER_ID, ts: new Date().toISOString() });
    if (history.length > 500) history.splice(0, history.length - 500);
    window.__glancePayloadHistory = history;
    window.__lastGlancePayload = () => [...history];
  }

  const eventMap = {
    'cart:view': 'view_cart',
    'collection:view': 'view_item_list',
    'custom_wishlist': 'add_to_wishlist',
  };

  Object.entries(eventMap).forEach(([sourceEvent, targetEvent]) => {
    document.addEventListener(sourceEvent, (event) => track(targetEvent, payloadFromEvent(event)));
  });

  document.addEventListener('kl:wishlist:toggle', (event) => {
    const payload = payloadFromEvent(event);
    if (payload?.active === false || payload?.isAdded === false) return;
    track('add_to_wishlist', payload);
  });

  window.__glancePixelBridge = {
    advertiser: ADVERTISER_ID,
    track,
    isReady: typeof window.InmobiPixel === 'function',
  };
})();
